module.exports = __webpack_public_path__ + "media/images/rating_check_full-711f0b47d70cade5842604a0c842506e.svg";